module.exports = __webpack_public_path__ + "static/polystyles-75da454323d6921052a9c09944ebccf1.png";